import { Controller, useFormContext, useWatch } from 'react-hook-form'

import { FF2, TextInput } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { useSubjectInformationItemContext } from '../../../SubjectInformationItemContext'

export const FirstName = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()
  const { isAllInfoUnavailable } = useSubjectInformationItemContext()
  const isEntity = useWatch({ control, name: `subjectsInfo.${index as 0}.isEntity` })

  return (
    <Controller
      name={`subjectsInfo.${index as 0}.firstName`}
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          label="5. First name"
          input={(props) => <TextInput {...props} disabled={isAllInfoUnavailable || isEntity} />}
        />
      )}
    />
  )
}
